import React from 'react';

import {MenuList} from 'react-select/lib/components/Menu';

import {gt} from 'app/utils/i18n';

import type {ExtraPropsType} from '../SweetReactSelect';

interface Props<IT> {
  data: IT | Array<IT>;
  children: React.ReactNode;
  selectProps: {
    isLoading?: boolean;
    extraProps?: ExtraPropsType<IT>;
  };
}

export function SelectMenuList<IT>({
  children,
  selectProps,
  ...other
}: Props<IT>) {
  const {hasNext, loadNext, loadingLast, onLimit} =
    selectProps.extraProps || {};
  return (
    <MenuList {...other}>
      {children}
      {!onLimit && !selectProps.isLoading && (hasNext || loadingLast) ? (
        <div className="text-center py-1 px-5 border-top">
          <button
            type="button"
            disabled={loadingLast}
            className="btn btn-link btn-sm btn-block"
            onClick={loadNext}
          >
            {loadingLast ? gt('Loading...') : gt('Show more')}
          </button>
        </div>
      ) : null}
    </MenuList>
  );
}
